export default {
  noData: 'Žiadne dáta na porovnanie',
};
